var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('el-popover',{attrs:{"trigger":"click","width":"200","placement":"bottom"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('el-button',{staticClass:"limit-text",attrs:{"slot":"reference","type":"text"},slot:"reference"},[_vm._v(_vm._s(_vm.text))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }